import { createStyles, makeStyles } from '@mui/styles';
import { Colors, Icons } from 'copyright-clearance-center-common-ui';

const useStyles = makeStyles(() =>
	createStyles({
		panelHeader: {
			display: 'flex',
			padding: '0.75rem 0 0.5rem 0',
			alignItems: 'center',
			justifyContent: 'space-between'
		},
		headerTitle: {
			display: 'flex',
			gap: '0.5rem',
			alignItems: 'center',
			fontSize: '1.125rem',
			lineHeight: '1.5rem',
			color: Colors.neutral900,
			fontWeight: 500
		}
	})
);

export interface IPanelHeaderProps {
	title: string;
	onClose: () => void;
}

const PanelHeader: React.FunctionComponent<IPanelHeaderProps> = ({ title, onClose }) => {
	const classes = useStyles();

	return (
		<div className={classes.panelHeader}>
			<div className={classes.headerTitle}>{title}</div>
			<button type="button" className="rup-icon-btn rup-icon-btn--neutral rup-icon-btn--sm" onClick={onClose}>
				<span className="rup-icon" dangerouslySetInnerHTML={{ __html: Icons.CloseIcon }} />
			</button>
		</div>
	);
};

export default PanelHeader;
